var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0C10.925 0 12 1.099 12 2.455v.817h3.2c.442 0 .8.367.8.819a.81.81 0 0 1-.8.818h-.8v10.636C14.4 16.901 13.325 18 12 18H4c-1.325 0-2.4-1.099-2.4-2.455L1.599 4.91H.8a.81.81 0 0 1-.8-.818.81.81 0 0 1 .8-.818L4 3.272v-.817C4 1.099 5.075 0 6.4 0h3.2zm3.2 4.909H3.199L3.2 15.545a.81.81 0 0 0 .8.819h8a.81.81 0 0 0 .8-.819V4.91zM9.6 1.636H6.4a.81.81 0 0 0-.8.819v.817h4.8v-.817a.81.81 0 0 0-.8-.819z",
    id: "bin"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#8F9BB3",
    xlinkHref: "#bin",
    transform: "matrix(-1 0 0 1 20 3)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon-bin.57aeffaa.svg";
export { ForwardRef as ReactComponent };